module.exports = __webpack_public_path__ + "static/media/Fall15min.dbf7b6bf.png";